var React = require('react');
var scrollTo = require('../../../helpers/scrollTo');
require('./TableOfContents.css');

class TableOfContents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      documentHeight: 0
    }
    this.handleGoToTop = this.handleGoToTop.bind(this);
    this.firstTocItem = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('resize', e => {
      this.setState({
        height: (window.innerHeight - 158) + 'px'
      })
    })

    var documentHeight = document.querySelector('.pubr-main').scrollHeight;
    this.setState({
      documentHeight: documentHeight
    })

    var sections = this.props.sections.map((item) => {
      return {
        ...item,
        position: (document.getElementById(item.sectionId).offsetTop / document.querySelector('.pubr-main').scrollHeight) * 100
      }
    });
    this.props.setHeadingPositions(sections);

    const updateProgress = () => {
      var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
      var percentage = ((scrollTop / documentHeight) * 100) + 1;

      if (documentHeight - scrollTop + 500 < window.innerHeight) {
        percentage = 100;
      }

      var id;
      for (let i = 0; i < Array.from(sections).length; i++) {
        if (percentage > sections[i].position) {
          id = sections[i].sectionId;
        }
      }
      this.props.setActiveSection(id);

      this.setState({
        progress: percentage
      })
    }
    updateProgress();

    document.addEventListener('scroll', updateProgress.bind(this));
  }

  handleGoToTop(e) {
    e.preventDefault();
    scrollTo(0, 800);
  }

  render() {
    var items = this.props.sections.map((section, i) => {
      return (
        <TableOfContentsItem
          key={section.sectionId}
          section={section}
          activeSectionId={this.props.activeSectionId}
          isFirst={i===0}
          guiLang={this.props.guiLang}
        />
      );
    })
    return (
      <div id="pubr-sidebar" className="pubr-sidebar__toc" tabIndex="-1">
        <div className="pubr-icon-button pubr-icon-button--up">
          <button onClick={this.handleGoToTop}>
            <span>Till toppen av sidan</span>
          </button>
        </div>
            <nav className="pubr-sidebar__toc__scrollable" aria-label={this.props.guiLang == "sv" ? "Avsnittsmeny" : "Section menu"}>
          <ul className="pubr-sidebar__toc__list">
            {items}
          </ul>
        </nav>
      </div>
    )
  }
}

class TableOfContentsItem extends React.Component {
  constructor(props) {
    super(props);
    this.handleToggleSubsections = this.handleToggleSubsections.bind(this)
    this.state = {
      expanded: false
    }
    this.link = React.createRef();
    this.isActive = this.isActive.bind(this);
  }

  isActive() {
    return this.props.section.sectionId === this.props.activeSectionId;
  }

  render() {
    const section = this.props.section;
    const href = `#${section.sectionId}`;
    const subSections = this.getSubSections(section.subSections);
    let className = this.isActive() ? "active" : "";

    if (this.state.expanded) {
      className += " expanded";
    }
    return (
      <li>
        <div>
          <a ref={this.link} href={href} onClick={this.handleGotoChapter.bind(section)} className={className} lang={section.language}>
            {section.sectionHeading}
          </a>
          {subSections &&
            <button onClick={this.handleToggleSubsections}>
                    <span class="off-screen">{this.props.guiLang == "sv" ? "Expandera underrubriker" : "Expand subheadings"}</span>
            </button>
          }
        </div>
        {this.state.expanded &&
          <ul>
            {subSections}
          </ul>
        }
      </li>
    )
  }

  componentDidMount() {
    if (this.props.isFirst) {
      this.link.current.focus();
    }
    if (this.isActive()) {
      this.link.current.focus();
    }
  }

  getSubSections(subSections) {
    if (subSections.length === 0) {
      return null;
    }
    const markup = subSections.map((subSection) => {
      const heading = document.getElementById(subSection.sectionId);
      const href = `#${subSection.sectionId}`;
      const className = ["pubr-toc-subsection",
        this.isInViewPort(heading) ? "active" : ""].join(" ") ;

      return (
        <li className={className} key={subSection.sectionId}>
          <a href={href}
            onClick={this.handleGotoChapter.bind(subSection)}
          >
            {subSection.sectionHeading}
          </a>
        </li>
      );
    })
    return markup;
  }

  isInViewPort(element) {
    const bounds = element.getBoundingClientRect();
    return (
        bounds.top >= 0 &&
        bounds.left >= 0 &&
        bounds.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounds.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  handleGotoChapter(e) {
    e.preventDefault();
    window.history.pushState(null, null, `#${this.sectionId}`);
    scrollTo(document.getElementById(this.sectionId).offsetTop - 100, 2000);
    document.getElementById(this.sectionId).focus();
  }


  handleToggleSubsections(e) {
    e.preventDefault();
    this.setState({
      expanded: !this.state.expanded
    });
  }
}

module.exports = TableOfContents;


// WEBPACK FOOTER //
// ./src/modules/reader/components/TableOfContents.js